// frontend/src/utils/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  timeout: 30000, // INCREASED TO 30 SECONDS
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('accessai-user') || 'null');
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle token expiration
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('accessai-user');
      window.location.href = '/login';
    }
    
    // Handle model limit errors
    if (error.response?.status === 429) {
      console.warn('Model limit reached:', error.response.data);
    }
    
    return Promise.reject(error);
  }
);

// Auth API calls
export const authAPI = {
  login: (email, password) => 
    api.post('/api/auth/login', { email, password }),
  
  signup: (email, password) => 
    api.post('/api/auth/signup', { email, password })
};

// Chat API calls
export const chatAPI = {
  sendMessage: (data) => 
    api.post('/api/chat', data)
};

// DSA API calls
export const dsaAPI = {
  getLesson: (data) => 
    api.post('/api/dsa/lesson', data),
  
  generateProblem: (data) => 
    api.post('/api/dsa/generate-problem', data),
  
  reviewCode: (data) => 
    api.post('/api/dsa/code-review', data)
};

// User API calls
export const userAPI = {
  getProfile: () => 
    api.get('/api/user/profile'),
  
  updatePoints: (points, achievement) => 
    api.post('/api/user/update-points', { points, achievement }),
  
  getLeaderboard: (params) => 
    api.get('/api/user/leaderboard', { params })
};

// Model API calls
export const modelAPI = {
  getAvailableModels: () => 
    api.get('/api/models/available'),
  
  updateModel: (modelId) => 
    api.post('/api/models/update', { model: modelId }),
  
  getModelStats: () => 
    api.get('/api/models/stats')
};

export default api;